import { ReactNode } from "react";
import "./ItemMenu.css";
import dots from "../../../assets/icons/dots.png";
import { Status } from "../status/Status/Status";
import { IconButton } from "../buttons/IconButton/IconButton";
import { BorderWrap } from "../wrappers/BorderWrap/BorderWrap";

interface ItemMenuProps {
  status?: "inactive" | "preorder" | "new" | "available";
  showMenu: boolean;
  menuClick: () => void;
  children: ReactNode;
}

export const ItemMenu = ({
  status,
  showMenu,
  menuClick,
  children,
}: ItemMenuProps) => {
  return (
    <div className="item-menu-wrap">
      {status && <Status status={status} />}
      <IconButton icon={dots} action={menuClick} color="violet" />
      {showMenu && (
        <div className="item-menu">
          <BorderWrap color="violet">{children}</BorderWrap>
        </div>
      )}
    </div>
  );
};
